export default __webpack_public_path__ + "navigation-examples-custom-waypoint-thumbnail-480-9e4e1c179d2d93140268ba5df0e3999d.png";